import React from "react";
import { useParams } from "react-router-dom";
import Breadcrumbs from "../../../Breadcrumbs/Breadcrumbs.js";
import data from "../../../Data/specialists/specialistsData.json";

export default function SpecialistsDetail() {
  const { slug } = useParams();

  const person = data.find((p) => p.slug === slug);

  if (!person) {
    return <p>Сотрудник не найден</p>;
  }

  return (
    <section className="contacts education staff-detail">
      <Breadcrumbs />

      <div className="staff-detail__wrapper">
        <div className="staff-detail__photo">
          <img src={person.photo} alt={person.name} />
        </div>

        <div className="staff-detail__info">
          <h1 className="staff-detail__name">{person.name}</h1>

          <h2 className="staff-detail__position">{person.position}</h2>

          {/* образование */}
          {person.education && (
            <p className="staff-detail__text">{person.education}</p>
          )}

          {/* документы */}
          {person.documents?.length > 0 && (
            <div className="staff-detail__bio">
              {person.documents.map((doc, index) => (
                <p key={index}>{doc}</p>
              ))}
            </div>
          )}

          {/* категория + степень */}
          <p className="staff-detail__text">
            {person.category || ""} {person.degree ? ` / ${person.degree}` : ""}
          </p>

          {/* стаж */}
          {person.experience && (
            <p className="staff-detail__text">{person.experience}</p>
          )}

          {/* направление */}
          {person.direction && (
            <p className="staff-detail__text">{person.direction}</p>
          )}
        </div>
      </div>
    </section>
  );
}
